import React from 'react';
import { Input, Select } from '../../../components/ui/Input';

const OPCOES_MODAL = [
  { value: 'rodoviario', label: 'Rodoviário' },
  { value: 'aereo', label: 'Aéreo' },
  { value: 'ferroviario', label: 'Ferroviário' },
  { value: 'maritimo', label: 'Marítimo' },
  { value: 'multimodal', label: 'Multimodal' }
];

export default function TransporteTab({ form, onChange }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
      <Input label="RNTRC" value={form.rntrc || ''} onChange={e => onChange('rntrc', e.target.value)}
        placeholder="Registro Nacional de Transportadores" />
      <Select label="Modal de Transporte" options={OPCOES_MODAL} value={form.modal_transporte || 'rodoviario'} onChange={e => onChange('modal_transporte', e.target.value)} />
      <Input label="Prazo Médio de Entrega (dias)" type="number" min="0" value={form.prazo_medio_entrega_dias || ''} onChange={e => onChange('prazo_medio_entrega_dias', e.target.value)} />
      <Input label="Regiões Atendidas" style={{ gridColumn: '1 / -1' }} value={form.regioes_atendidas || ''} onChange={e => onChange('regioes_atendidas', e.target.value)}
        placeholder="Ex: SP, RJ, MG — Sudeste" />
    </div>
  );
}
